var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c18818555ceee1e0a0b81e434ef91318ec3e93eb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@salespack"]={id:"c18818555ceee1e0a0b81e434ef91318ec3e93eb"};
      